import React from "react";

import { useStyles } from "./styles";

type FloatedButtonProps = {
    floated?: boolean,
    withGradient?: boolean,
    bottomPadding?: boolean,
    children?: any,
    className?: string,
}

export const FloatedButton = ({ children, floated, withGradient, bottomPadding, className }: FloatedButtonProps) => {
    const { floatedButtonWrapper, gradient, padding } = useStyles();

    if (!floated) return children;

    let floatedButtonClass = `${floatedButtonWrapper} ${className} `;

    if (withGradient) {
        floatedButtonClass += `${gradient}`;
    }

    if (bottomPadding) {
        floatedButtonClass += `${padding}`;
    }

    return (
        <div className={floatedButtonClass}>
            {children}
        </div>
    )
};
